import { MouseEventHandler } from 'react';

import { CmsTileModalCloseButton } from 'modules/cms/modals/TileModal/CloseButton/CmsTileModalCloseButton';

import {
  TileModalDesktopHeaderBlueLine,
  TileModalDesktopHeaderCloseContainer,
  TileModalDesktopHeaderContainer,
} from './CmsTileModalDesktopHeader.styled';

type Props = {
  onClose: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalDesktopHeader({ onClose }: Props) {
  return (
    <TileModalDesktopHeaderContainer>
      <TileModalDesktopHeaderBlueLine />

      <TileModalDesktopHeaderCloseContainer>
        <CmsTileModalCloseButton onClick={onClose} />
      </TileModalDesktopHeaderCloseContainer>
    </TileModalDesktopHeaderContainer>
  );
}
